"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerializedCircuitStateOrPointerSchema = exports.ISerializedCircuitStatePointerSchema = exports.SerializedCircuitStateMapSchema = exports.ISerializedCircuitStateSchema = void 0;
const zod_1 = require("zod");
const BoundaryCharacteristicStateSummaryExternal_1 = require("./BoundaryCharacteristicStateSummaryExternal");
const ComponentFunctionStatesSerialized_1 = require("./ComponentFunctionStatesSerialized");
const ISerializedBoundaryConfiguration_1 = require("./ISerializedBoundaryConfiguration");
const SerializedModeState_1 = require("./SerializedModeState");
exports.ISerializedCircuitStateSchema = zod_1.default.object({
    modes: zod_1.default.record(zod_1.default.string(), SerializedModeState_1.SerializedModeStateSchema),
    nets: zod_1.default.record(zod_1.default.string(), zod_1.default.lazy(() => BoundaryCharacteristicStateSummaryExternal_1.BoundaryCharacteristicStateSummaryExternalSchema).array()),
    functionStates: zod_1.default.lazy(() => ComponentFunctionStatesSerialized_1.SerializedComponentFunctionsMapSchema),
    boundaries: zod_1.default.record(zod_1.default.string(), zod_1.default.lazy(() => ISerializedBoundaryConfiguration_1.ISerializedBoundaryConfigurationSchema)),
});
exports.SerializedCircuitStateMapSchema = zod_1.default.record(zod_1.default.string(), exports.ISerializedCircuitStateSchema);
exports.ISerializedCircuitStatePointerSchema = zod_1.default.object({
    csId: zod_1.default.string(),
});
exports.SerializedCircuitStateOrPointerSchema = zod_1.default.union([
    exports.ISerializedCircuitStateSchema,
    exports.ISerializedCircuitStatePointerSchema,
]);
//# sourceMappingURL=ISerializedCircuitState.js.map